<template>
  <div id="page-not-found"> 
    <div>
      <h1>Error 404</h1>
      <p>Page not found</p>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="sass" >
  #page-not-found
    display: -webkit-flex
    display:         flex
    height: 70vh
    -webkit-align-items: center
            align-items: center  
    div
      margin: 0 auto
      h1
        font-size: 64px
      p 
        font-size: 28px
</style>



// WEBPACK FOOTER //
// 404.vue?660d37ac